<template>
	<div>
		<section class="bottom-images">
			<div class="row large-row">
				<div v-for="image in images" :key="image.ID" class="columns column4">
					<picture>
						<source :srcset="image.imageWebp" type="image/webp" />
						<source :srcset="image.image" />
						<img :src="image.image" :alt="image.imageAlt" loading="lazy" />
					</picture>
					<div v-parse-links v-html="image.content" />
				</div>
			</div>
		</section>
	</div>
</template>

<script setup>
defineProps({
	images: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.bottom-images {
	.column4 {
		padding: 0 20px;
	}

	img {
		margin: 20px 0;
	}
}
</style>
